import { SVGProps } from 'react';
import cn from 'classnames';

import Link from '@/components/renderers/Link';

interface DropdownLinkProps {
  href: string;
  title: string;
  subTitle?: string;
  icon: (props: SVGProps<SVGSVGElement>) => JSX.Element;
}

export default function DropdownLink({
  href,
  title,
  subTitle,
  icon: Icon,
}: DropdownLinkProps) {
  return (
    <Link
      href={href}
      className={cn(
        `group flex w-full items-center lg:items-start`,
        !subTitle && `!items-center`,
      )}
    >
      <div className="flex h-5 w-5 flex-shrink-0 items-center justify-center">
        <Icon className="h-4 w-4 text-light-haiti group-hover:text-rose" />
      </div>
      <div className="ml-3 flex w-full flex-col">
        <p className="flex-shrink-0 text-[13px] leading-4 text-haiti group-hover:text-rose">
          {title}
        </p>
        {subTitle && (
          <p className="mt-1 hidden text-xs font-normal leading-4 text-light-haiti lg:inline">
            {subTitle}
          </p>
        )}
      </div>
    </Link>
  );
}
